import { browserHistory } from 'react-router';

import permissionVerifier from './permissionVerifier';

export default function loginCheckOnEnter(inLoginPage, pathName){
  let isLogin = sessionStorage.isLogin;
  if(inLoginPage) {
    if(isLogin) browserHistory.replace('/salesky');
  }else {
    if(!isLogin) browserHistory.replace('/login');
    else {
      // 新網址，且不是在login頁面且已經login狀態下，需確認頁面存取權限
      if(!permissionVerifier(pathName)) browserHistory.replace('/salesky');
    }
  }
}


// WEBPACK FOOTER //
// ./src/commonJS/loginCheckOnEnter.js